import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, SectionList, ScrollView } from 'react-native';
import { useStore } from 'Store';

import { getAssetTitle, ITEM_TYPES } from 'Utils';
import { NUMBERING_EPISODE } from '@24i/st-api-connector/utils';
import { getFirstEpisode } from 'Utils/itemUtils';
import PlayListItem from './PlayListItem';
import SectionPlayListHeader from './SectionPlayListHeader';
import { useNavigationPropsContext } from '../../Navigation/navigationPropsContext';

const styles = StyleSheet.create({
    sectionListContainer: {
        marginTop: 15,
        marginBottom: 28
    }
});

const SeriesList = (props) => {
    const { appManager } = useStore();
    const { listData, listHeader, navigation, parentItem, onPlayPress, updateSeriesDetail } = props;
    const { navigationProps, updateNavigationProps, push, navigate } = useNavigationPropsContext();

    return (
        <ScrollView>
            <SectionList
                style={styles.sectionListContainer}
                renderItem={({ item }) => {
                    const title = getAssetTitle(item, NUMBERING_EPISODE, 'SeriesList.js');
                    const isRecording = item.modelType === ITEM_TYPES.RECORDING;
                    const hasStarted = item.data?.start <= Date.now();
                    let canPlay = !isRecording && hasStarted;
                    let parentId;
                    const firstEpisode = getFirstEpisode(item.episodes);
                    if (item.modelType === ITEM_TYPES.SEASON) {
                        canPlay = Boolean(firstEpisode);
                        parentId = item?.series?.id;
                    }
                    if (item.modelType === ITEM_TYPES.EPISODE) {
                        canPlay = true;
                        parentId = item?.season.getId();
                    }

                    //check if item in recordings is still in live and if is, behave in navigation as live item not recording
                    const endTimeUTC = item?.data?.schedule?.endTimeUTC;
                    const type = item?.modelType;

                    const isAfterCurrentTime = (endTimeUTC) => {
                        if (!endTimeUTC) return false;
                        return endTimeUTC > Date.now();
                    };

                    const checkRecordingLive = (item) => {
                        if (type !== ITEM_TYPES.RECORDING_SERIES) {
                            return isAfterCurrentTime(endTimeUTC) ? ITEM_TYPES.TV : type;
                        } else {
                            return item.modelType;
                        }
                    };
                    return (
                        <PlayListItem
                            canPlay={canPlay}
                            title={title}
                            onPress={() => {
                                /**
                                 * Have to be navigation.push because instance of detail
                                 *  needs to be replaced not navigated again */
                                push(
                                    'Details',
                                    { item },
                                    {
                                        id: item.getId(),
                                        parentId,
                                        type: checkRecordingLive(item),
                                        platform: item.data?.pckg?.platform
                                    }
                                );
                            }}
                            onPlayPress={async () => {
                                if (isRecording) {
                                    const programItem = await appManager
                                        .getApi()
                                        .fetchProgramDetail({
                                            scheduleId: item.getId()
                                        });
                                    onPlayPress({ item: programItem });
                                } else if (item.modelType === ITEM_TYPES.SEASON) {
                                    onPlayPress({ item: firstEpisode, checkEntitlements: true });
                                } else {
                                    onPlayPress({ item, checkEntitlements: true });
                                }
                            }}
                        />
                    );
                }}
                renderSectionHeader={({ section: { title } }) => (
                    <SectionPlayListHeader title={title} />
                )}
                sections={[{ title: listHeader, data: listData }]}
                keyExtractor={(item, index) => item + index}
            />
        </ScrollView>
    );
};

SeriesList.propTypes = {
    listData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    listHeader: PropTypes.string.isRequired,
    navigation: PropTypes.shape({}).isRequired,
    parentItem: PropTypes.shape({}).isRequired,
    onPlayPress: PropTypes.func.isRequired,
    updateSeriesDetail: PropTypes.func.isRequired
};

export default SeriesList;
